import { configureStore } from "store/configureStore";

export const { store, persistor } = configureStore();
